import { Component } from '@angular/core';

@Component({
  selector: 'met-explanation',
  templateUrl: './explanation.component.html',
  styleUrls: ['./explanation.component.scss']
})
export class ExplanationComponent {
}
